import {
    SHOW_LOADING,
    HIDE_LOADING,
    GET_TEMPLATE_LIST,
    ADD_TEMPLATE,
    UPDATE_TEMPLATE,
    TEMPLATE_LIST,
    DELETE_TEMPLATE,
    SET_ADD_EDIT,
    TEMPLATE_MESSAGE,
    GET_TEMPLATE_PAGE_LIST,
    TEMPLATE_PAGE_LIST,
    ADD_TEMPLATE_PAGE,
    UPDATE_TEMPLATE_PAGE,
    DELETE_TEMPLATE_PAGE,
    TEMPLATE_PAGE_MESSAGE,
    GET_TEMPLATE_PAGE_DRAFT_LIST,
    TEMPLATE_PAGE_DRAFT_LIST,
    ADD_TEMPLATE_PAGE_DRAFT,
    UPDATE_TEMPLATE_PAGE_DRAFT,
    DELETE_TEMPLATE_PAGE_DRAFT,
    TEMPLATE_PAGE_DRAFT_MESSAGE,
    TAB_VALUE,
    ADD_TEMPLATE_PAGE_PUBLISH,
    UPDATE_TEMPLATE_PAGE_PUBLISH,
    GET_TEMPLATE_LIST_WITH_PAGES,
    TEMPLATE_LIST_WITH_PAGES
  } from "redux/constants/templatePage";
  
  export const getTemplateList = (requestData) => {
    return {
      type: GET_TEMPLATE_LIST,
      payload: requestData,
    };
  };
  
  export const getTemplateListWithPages = (requestData) => {
    return {
      type: GET_TEMPLATE_LIST_WITH_PAGES,
      payload: requestData,
    };
  };

  export const templates = (templates)=> {
      return {
          type: TEMPLATE_LIST,
          payload: templates,
        };
  }
  
  export const templatesWithPages = (templatesWithPages)=> {
    return {
        type: TEMPLATE_LIST_WITH_PAGES,
        payload: templatesWithPages,
      };
}
  export const addTemplate = (data) => {
    return {
      type: ADD_TEMPLATE,
      payload: data,
    };
  };
  
  export const updateTemplate = (data) => {
    return {
      type: UPDATE_TEMPLATE,
      payload: data,
    };
  };
  
  export const deleteTemplate = (appTemplate) => {
      return {
        type: DELETE_TEMPLATE,
        payload: appTemplate,
      };
    };
  
  export const showTemplateMessage= (response) =>{
    return {
      type: TEMPLATE_MESSAGE,
      response,
    };
  }
  
  export const getTemplatePageDraftList = (requestData) => {
    return {
      type: GET_TEMPLATE_PAGE_DRAFT_LIST,
      payload: requestData,
    };
  };
  
  export const templatePagesDraft = (templatePagesDraft)=> {
      return {
          type: TEMPLATE_PAGE_DRAFT_LIST,
          payload: templatePagesDraft,
        };
  }
  
  export const addTemplatePageDraft = (data) => {
    return {
      type: ADD_TEMPLATE_PAGE_DRAFT,
      payload: data,
    };
  };
  
  export const updateTemplatePageDraft = (data) => {
    return {
      type: UPDATE_TEMPLATE_PAGE_DRAFT,
      payload: data,
    };
  };

  export const addTemplatePagePublish = (data) => {
    return {
      type: ADD_TEMPLATE_PAGE_PUBLISH,
      payload: data,
    };
  };
  
  export const updateTemplatePagePublish = (data) => {
    return {
      type: UPDATE_TEMPLATE_PAGE_PUBLISH,
      payload: data,
    };
  };
  
  export const deleteTemplatePageDraft = (appTemplatePageDraft) => {
      return {
        type: DELETE_TEMPLATE_PAGE_DRAFT,
        payload: appTemplatePageDraft,
      };
    };
  
  export const showTemplatePageDraftMessage= (response) =>{
    return {
      type: TEMPLATE_PAGE_DRAFT_MESSAGE,
      response,
    };
  }

  export const setAddEditPages = (value) => {
      return {
          type: SET_ADD_EDIT,
          addEditPagesValue: value,
      };
  };

  export const switchTabs = (value)=>{
    return {
      type: TAB_VALUE,
      selectedTab: value,
  };
  }
  
  export const showLoading = () => {
      return {
        type: SHOW_LOADING,
      };
    };
    
    export const hideLoading = () => {
      return {
        type: HIDE_LOADING,
      };
    };